import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext({ user: null, loading: true, login: async () => {}, logout: () => {} });

export const useAuth = () => useContext(AuthContext);

export const authHeaders = () => {
  const t = localStorage.getItem("ptt_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/auth/me`, { headers: authHeaders() });
      setUser(data);
    } catch {
      setUser(null);
      localStorage.removeItem("ptt_admin_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("ptt_admin_token")) {
      fetchMe();
    } else {
      setLoading(false);
    }
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("ptt_admin_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`, {}, { headers: authHeaders() }); } catch (_) {}
    localStorage.removeItem("ptt_admin_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
